import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import Store from './Store';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './AuthPages/AuthProvider';

const msalInstance = new PublicClientApplication(msalConfig);




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

        <Provider store={Store}>
                <MsalProvider instance={msalInstance}>
                <App />
                </MsalProvider>

                <ToastContainer
                        position="bottom-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                        
/>
        </Provider>


);

